

































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskDateTime, onlyNumber } from '@/utils/common'
import SuporteHospitaisRemuneracaoStore from '../store/SuporteHospitaisRemuneracaoStore'

@Component
export default class ModalSuporteVisualizarGrupo extends Vue {
  @Prop({ default: false }) visualizar!: boolean

  tiposDeCargaTextarea: string = ''
  loadSaveOrUpdateHospital: boolean = false

  getSuporteHospitaisRemuneracaoStore = getModule(SuporteHospitaisRemuneracaoStore, this.$store)

  get loadingSaveOrUpdateHospital() { return this.loadSaveOrUpdateHospital }
  set loadingSaveOrUpdateHospital(value: boolean) { this.loadSaveOrUpdateHospital = value }

  get hospitalDetails() {
    return this.getSuporteHospitaisRemuneracaoStore.grupoHospitalDetails
  }

  get selectedTiposDeCarga() {
    return this.hospitalDetails.tiposDeCarga
  }

  set selectedTiposDeCarga(value: any) {
    this.getSuporteHospitaisRemuneracaoStore.setTiposCargaSelected(value)
  }

  get selectedCalculoModoDisparo() {
    return this.hospitalDetails.calculoModoDisparo
  }

  set selectedCalculoModoDisparo(value: any) {
    this.getSuporteHospitaisRemuneracaoStore.setCalculoModoDisparoSelected(value)
  }

  get createdOn() {
    return this.formatDateTime(this.hospitalDetails.createdOn)
  }

  get showModalHospital() {
    return this.getSuporteHospitaisRemuneracaoStore.modal.visualizarGrupo
  }

  set showModalHospital(value: boolean) {
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'visualizarGrupo', value })
  }

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  onlyNumberUtil(e: KeyboardEvent) {
    return onlyNumber(e)
  }

  async saveOrUpdateHospital() {
    this.loadingSaveOrUpdateHospital = true
    if (this.hospitalDetails.id) {
      await this.getSuporteHospitaisRemuneracaoStore.updateGrupoHospital()
      this.closeModal()
    } else {
      await this.getSuporteHospitaisRemuneracaoStore.createGrupoHospital()
      this.closeModal()
    }
    this.loadingSaveOrUpdateHospital = false
  }

  async closeModal() {
    await this.getSuporteHospitaisRemuneracaoStore.getGrupoHospital()
    this.getSuporteHospitaisRemuneracaoStore.clearHospitaisDetails()
    this.showModalHospital = false
  }
}
